import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

const ADMIN_EMAIL = 'pascaltombere1@gmail.com';

/**
 * Wraps a route so it is exclusively accessible to the admin.
 * - Checks the live Supabase session (not just the regular AuthContext)
 * - Also verifies the sessionStorage flag set at AdminLogin
 * - Any other user hits /admin-login, not the regular /login
 */
const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const [status, setStatus] = useState<'loading' | 'allowed' | 'denied'>('loading');

  useEffect(() => {
    const verify = async () => {
      // Quick flag check first
      const flag = sessionStorage.getItem('bravax_admin_session');
      if (!flag) { setStatus('denied'); return; }

      // Double-check with live session
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user?.email === ADMIN_EMAIL) {
        setStatus('allowed');
      } else {
        sessionStorage.removeItem('bravax_admin_session');
        setStatus('denied');
      }
    };
    verify();
  }, []);

  if (status === 'loading') {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#0a0a0a',
      }}>
        <Loader2 size={32} color="#ef4444" style={{ animation: 'spin 1s linear infinite' }} />
        <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
      </div>
    );
  }

  if (status === 'denied') return <Navigate to="/admin-login" replace />;

  return <>{children}</>;
};

export default AdminRoute;
